import { CartAddEvent } from '@theme/events';
const drawer = () => document.querySelector('[data-eco-native-cart] cart-drawer-component');
const closeConcierge = () => document.querySelector('[data-eco-sms-dialog][open]')?.close();
customElements.whenDefined('cart-drawer-component').then(() => drawer()?.setAttribute('auto-open', ''));
document.addEventListener('click', event => {
  const link = event.target.closest('[data-eco-bag]');
  if (!link || event.metaKey || event.ctrlKey || event.shiftKey || !drawer()?.open) return;
  event.preventDefault(); closeConcierge(); drawer().open();
});
document.addEventListener('submit', async event => {
  const form = event.target.closest('.eco-offer-form');
  if (!form || !drawer()?.open) return; // Keep native POST when enhancement is unavailable.
  event.preventDefault();
  if (form.dataset.pending === 'true') return;
  const button = form.querySelector('button[type="submit"]'), status = form.querySelector('[role="status"]'), recovery = form.querySelector('.eco-purchase-recovery');
  if (button.disabled) return;
  form.dataset.pending = 'true'; button.disabled = true; status.textContent = 'Adding to your bag…'; recovery.hidden = true;
  let added = false;
  const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 15000);
  try {
    const data = new FormData(form);
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(x => x.dataset.sectionId))];
    data.set('sections', sections.join(',')); data.set('sections_url', location.pathname);
    const response = await fetch(form.action + '.js', {method:'POST',body:data,signal:controller.signal,headers:{Accept:'application/json'}});
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'This item could not be added. Please try again.');
    added = true;
    if (!sections.length || sections.some(id => !result.sections?.[id])) throw new Error('Cart display unavailable');
    closeConcierge();
    document.dispatchEvent(new CartAddEvent({}, String(data.get('id')), {source:'eco-offer',itemCount:1,sections:result.sections}));
    status.textContent = 'Added to your bag.';
    recovery.hidden = false;
  } catch (error) {
    recovery.hidden = false;
    status.textContent = added ? 'Added to your bag. Open your cart to review it.' : ((error instanceof TypeError || error.name === 'AbortError') ? 'We could not confirm the update. Check your cart before trying again.' : error.message);
  } finally { clearTimeout(timeout); form.dataset.pending = 'false'; button.disabled = false; }
});
